import moment from 'moment-timezone'

// Display-only: never rewrite the source date in the lead or the database.
export function formatLeadCreationDate(lead, fallbackTimezone) {
  if (!lead || !lead.lead_creation_date) return '';
  const target = lead.client_timezone || fallbackTimezone || 'UTC';
  const targetZone = moment.tz.zone(target) ? target : 'UTC';
  const sources = String(lead.sources || '').split(',').map(source => source.trim());
  // Imports append sources and preserve the original creation date. A bland,lsa
  // lead therefore still has a UTC creation date, whereas lsa,bland is Google-local.
  const googleZone = lead.google_ads_timezone;
  const sourceZone = sources[0] === 'lsa'
    ? (googleZone && moment.tz.zone(googleZone) ? googleZone : targetZone)
    : 'UTC';
  const date = moment.tz(lead.lead_creation_date, sourceZone);
  return date.isValid() ? date.tz(targetZone).format('ddd M/D/YYYY h:mm:ss A') : '';
}
